import classnames from 'classnames'
import { useEffect, useState } from 'react'

import useClickOutSide from '@src/quince-site-common/src/hooks/useClickOutSide'
import { ProductProperties } from '@src/telemetry/getProductPropertiesForTracking'
import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'

import DownArrowIcon from '../../../icons/downArrow.inline.svg'

import styles from './select.module.scss'

export interface SelectOptionProps {
  label: string
  value: string
}

export interface SelectProps {
  options: SelectOptionProps[]
  label: string
  onChange: (val: string) => void
  className?: string
  labelWrapperClassName?: string
  variants?: any
  hasPhoto?: boolean
  productProperties?: ProductProperties
  optionWrapperClassName?: string
  trackNewSortEvent?: boolean
  labelClassName?: string
}

export const Select = ({
  className = '',
  labelWrapperClassName = '',
  options,
  label,
  onChange,
  variants,
  hasPhoto,
  productProperties,
  optionWrapperClassName,
  trackNewSortEvent = false,
  labelClassName = '',
}: SelectProps) => {
  const [selected, setSelectedVal] = useState('')
  const { ref, isOpen, setIsOpen } = useClickOutSide()
  useEffect(() => {
    onChange(selected)
  }, [onChange, selected])

  return (
    <div className={classnames(styles.selectBoxWrap, className)} ref={ref}>
      <div
        data-testid="review-section-sortby-heading"
        className={classnames('dropdownTitle', styles.dropdownTitle, labelWrapperClassName)}
        onClick={() => {
          setIsOpen(!isOpen)
          if (trackNewSortEvent) {
            trackEvent(TELEMETRY_EVENT_NAMES.SORT_OPENED, {
              context: {
                contentContainerDisplayName: 'Product Rating & Reviews',
                contentContainerName: 'Sort and Filter Options',
                contentContainerType: 'Sort',
                productProperties,
              },
            })
          }
        }}
      >
        <span className={classnames(styles.label, labelClassName)}>{label}</span>{' '}
        <DownArrowIcon className={classnames(styles.dropdownIcon, { [styles.open]: isOpen })} />
      </div>
      <ul
        data-testid="review-section-sortby-content"
        className={classnames(styles.optionsWrap, { [styles.show]: isOpen }, optionWrapperClassName)}
      >
        {options.map((item: SelectOptionProps, index: number) => {
          return (
            <li
              data-testid={`review-section-sortby-value-${item.value}}`}
              key={item.label}
              onClick={() => {
                setSelectedVal(item.value)
                setIsOpen(false)
                trackEvent(TELEMETRY_EVENT_NAMES.REVIEWS_SORTED, {
                  product_id: variants[0]?.productId,
                  has_photo_filter: hasPhoto,
                  productProperties,
                })
                if (trackNewSortEvent) {
                  trackEvent(TELEMETRY_EVENT_NAMES.SORT_USED, {
                    sort_used: item.value,
                    context: {
                      contentContainerDisplayName: 'Product Rating & Reviews',
                      contentContainerName: 'Sort and Filter Options',
                      contentContainerType: 'Sort',
                      productProperties,
                    },
                  })
                }
              }}
              className={classnames(styles.optionItem, {
                [styles.selected]: item.value === selected || (!selected && index === 0),
              })}
            >
              {item.label}
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Select
